import React from 'react';

function Payments() {
  return <div>Payments management page</div>;
}

export default Payments;
